export class ChaCompanyMasterVO {
    public id: number;
    public chaLincenseNo: string;
    public chaName: string;
    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public postalCode: string;
    public gstNo: string;
    public contactFirstname: string;
    public contactSecondname: string;
    public email: string;
    public mobile: string;
    public checks: boolean;
    public regNo: string;

}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/ChaCompanyMasterVO.ts